module.exports = __webpack_public_path__ + "static/media/44@2x.bdf2990e.png";